import { Pipe, PipeTransform } from '@angular/core';
import { Contact, ContactSummary, ContactUtility } from '@jms/model';

@Pipe({
  name: 'fullName',
  pure: false,
  standalone: true
})
export class FullNamePipe implements PipeTransform {

  transform(contact: Contact | ContactSummary, title: boolean = false): string {
    const fullName = ContactUtility.getFullName(contact);

    const displayTitle = title && !!contact?.title;

    if (displayTitle) {
      return `${fullName} - ${contact?.title}`;
    }

    return fullName;
  }

}
